export const PERMISSION_READ = 'read'
export const PERMISSION_EDIT = 'edit'
export const PERMISSION_OWNER = 'owner'
export const PERMISSION_NONE = 'none'
